module.exports = __webpack_public_path__ + "mCSB_buttons.png?3a8a4582fe1dbc77086eccca317c459e";


//////////////////
// WEBPACK FOOTER
// ./node_modules/malihu-custom-scrollbar-plugin/mCSB_buttons.png
// module id = 66
// module chunks = 0